import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BusinessModel} from '../../../../core-logic/models/business/business-model';
import {CustomizerModel} from '../../../../core-logic/models/business/sub/customizer-model';
import * as _ from 'lodash';

@Component({
  selector: 'app-card-customizer',
  templateUrl: './card-customizer.component.html',
  styleUrls: ['./card-customizer.component.scss'],
})
export class CardCustomizerComponent {
  @Input() businessModel: BusinessModel = {} as BusinessModel;
  @Input() logoUri = '';
  @Output() customizer = new EventEmitter<CustomizerModel>();
  @Output() logoUploadPercentageGateway = new EventEmitter<number>();
  @Output() initializedLogoUri = new EventEmitter<string>();
  backgroundColors = BACKGROUND_COLORS;
  textColors = TEXT_COLORS;
  customizerModel: CustomizerModel = {} as CustomizerModel;

  constructor() {}

  selectBackgroundColor(backgroundColor: string) {
    this.customizerModel.background = backgroundColor;
    this.customizer.emit(_.merge(this.businessModel.customizer, this.customizerModel));
  }

  selectTextColor(textColor: string) {
    this.customizerModel.color = textColor;
    this.customizer.emit(_.merge(this.businessModel.customizer, this.customizerModel));
  }

  onUploadedLogoId(uploadedLogoId: string) {
    this.customizerModel.logo = uploadedLogoId;
    this.customizer.emit(this.customizerModel);
  }

  onLogoUploadPercentage(logoUploadPercentage: number) {
    this.logoUploadPercentageGateway.emit(logoUploadPercentage);
  }

  onInitializedLogoUri(initializedLogoUri: string) {
    this.initializedLogoUri.emit(initializedLogoUri);
  }
}

export const BACKGROUND_COLORS: string [] = [
  'radial-gradient( circle farthest-corner at 10% 20%,  rgb(90,92,106) 0%, rgb(32,45,58) 81.3% )',
  'white',
  'linear-gradient(to bottom left, rgb(52 173 120) 0%, rgb(59, 206, 135) 76%)',
  'linear-gradient(120deg, rgb(218, 85, 128) 0%, rgb(255 111 191) 100.2%)',
  'linear-gradient(80deg, rgb(255 208 107) 0%, rgb(255, 198, 36) 100.2%)',
  'linear-gradient(120deg, rgb(85 120 218) 0%, rgb(95 199 249) 100.2%)',
  'linear-gradient(120deg, rgb(121, 104, 197) 0%, rgb(193, 172, 249) 100%)',
  'linear-gradient(122deg, rgb(239 31 31) 0%, rgb(241 120 143) 100.2%)',
  'linear-gradient(214deg, rgb(255 199 149) 0%, rgb(255 222 209) 100.2%)',
  'linear-gradient(200deg, rgb(255 214 217) 0%, rgb(253 232 232) 100%)',
  'linear-gradient(200deg, rgb(226 246 207) 0%, rgb(241 247 228) 100%)',
  'linear-gradient(200deg, rgb(255 247 222) 0%, rgb(255 251 232) 76%)',
  'linear-gradient(223deg, rgb(220 203 253) 0%, rgb(228 220 251) 76%)',
];

export const TEXT_COLORS: string [] = ['#474747', 'grey', 'black', 'white'];
